var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "el-upload" },
    [
      _c(
        "el-form",
        [
          _c(
            "el-upload",
            {
              attrs: {
                limit: 1,
                action: "",
                drag: "",
                accept: _vm.suffix ? _vm.suffix : "*.*",
                "http-request": _vm.uploadFile,
                "auto-upload": true,
                "file-list": _vm.fileList,
                "on-remove": _vm.removeFile,
              },
            },
            [
              _c("i", { staticClass: "el-icon-upload" }),
              _c("div", { staticClass: "el-upload__text" }, [
                _vm._v("将文件拖到此处，或"),
                _c("em", [_vm._v("点击上传")]),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }